import React from 'react';
import { Card } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import SAP_Com from '../../Assets/SAP_Com.jpeg';
import SAP_Fiori from '../../Assets/SAP_Fiori.png';
import SAP_BuildCode from '../../Assets/SAP_BuildCode.png';
import Particle from '../Particle';
import CertImg from './ui/cert';

const blogCertcards = {
  list: [
    {
      name: 'SAP Community',
      image: SAP_Com,
      link: 'https://blogs.sap.com/2021/03/31/sap-ui5-drag-and-drop-functionality-for-tokenizercustom/',
      description:
        'Explore my blog on SAP Community where I share insights and tutorials on implementing drag-and-drop functionality for TokenizerCustom in SAP UI5.',
    },
    {
      name: 'SAP Certified Associate',
      image: SAP_Fiori,
      link: 'https://www.credly.com/badges/62798c7f-6ff7-4528-9a12-324d90c51582/public_url',
      description: 'SAP Fiori Application Developer',
    },
    {
      name: 'SAP Record of Achievement',
      image: SAP_BuildCode,
      link: 'https://www.credly.com/badges/151599d7-9462-4827-920d-3c9c54d1cce6/public_url',
      description:
        'Creating Applications and Extensions using SAP Build Code - Record of Achievement',
    },
  ],
};
function Blogs() {
  return (
    <div className="projects-main">
      <div className="basic-projects">
        <div className="projects-heading-div">
          <div className="projects-heading-img-div">
            <CertImg />
          </div>
          <div className="projects-heading-text-div">
            <h1 className="projects-heading-text">My Certifications & Blogs</h1>
          </div>
        </div>
      </div>
      <Particle />
      <div className="repo-cards-div-main card-grid">
        {blogCertcards.list.map((blog) => {
          return (
            <Card className="h-100">
              <Card.Img variant="top" className="ImageBlog" src={blog.image} />

              <Card.Body>
                <Card.Title>
                  <h3 style={{ lineHeight: '1.5', marginTop: '0' }}>
                    {blog.name}
                    <a
                      href={blog.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className={`fas fa-external-link-alt`}
                        style={{
                          color: 'white',
                          marginLeft: '10px',
                        }}
                      ></i>
                    </a>
                  </h3>
                </Card.Title>

                <div
                  className="text-center"
                  style={{ marginTop: '20px' }}
                ></div>

                <Card.Text className="cardtext">{blog.description}</Card.Text>
              </Card.Body>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

export default Blogs;
